import { render, staticRenderFns } from "./jbperc.vue?vue&type=template&id=bb9a3042&scoped=true"
import script from "./jbperc.vue?vue&type=script&lang=js"
export * from "./jbperc.vue?vue&type=script&lang=js"
import style0 from "./jbperc.vue?vue&type=style&index=0&id=bb9a3042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9a3042",
  null
  
)

export default component.exports